@if (formGroup) {
  <div>
    <!-- Enabled address form -->
    @if (!readOnly) {
      <form [formGroup]="formGroup" class="full-width container overflow-auto" autocomplete="off">
        @if (title) {
          <h1 class="full-width">
            {{ title | translate }}
          </h1>
        }
        <!-- User data -->
        @if (config.firstName.isVisible || config.lastName.isVisible || config.firmName.isVisible) {
          <div class="container width-portrait" [class.width-landscape]="showSalutationsTitleControl.value"
            >
            @if (config.firstName.isVisible) {
              <div class="content-row d-flex flex-column half-size">
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{'registerAddress.input.firstName.title' | translate}}
                  </mat-label>
                  <input matInput type="text" [id]="'intFirstName' + idSuffix" formControlName="firstName" />
                </mat-form-field>
              </div>
            }
            @if (config.lastName.isVisible) {
              <div class="content-row d-flex flex-column half-size ">
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{'registerAddress.input.lastName.title' | translate}}
                  </mat-label>
                  <input matInput type="text" [id]="'intLastName' + idSuffix" formControlName="lastName" />
                </mat-form-field>
              </div>
            }
            @if (config.firmName.isVisible) {
              <div class="content-row d-flex flex-column full-width">
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{'registerAddress.input.firmName.title' | translate}}
                  </mat-label>
                  <input matInput type="text" [id]="'intFirmName' + idSuffix" formControlName="firmName" />
                </mat-form-field>
                @if (formGroup.errors?.atLeastOneRequired && formGroup.touched) {
                  <div class="error">
                    * {{ 'tenant.dialog.edit.location.error.names' | translate }}
                  </div>
                }
              </div>
            }
          </div>
        }
        <!-- Salutaion area -->
        @if (showSalutationsTitleControl.value) {
          <div class="container width-portrait width-landscape height-fit-content"
            >
            @if (config.addressSalutation.isVisible) {
              <div class="content-row d-flex flex-column half-size">
                <mat-form-field appearance="outline" [id]="'sddAddressSalutation' + idSuffix ">
                  <mat-label>
                    {{'registerAddress.autocomplete.addressSalutation.title' | translate}}
                  </mat-label>
                  <input matInput type="text" [id]="'intAddressSalutation' + idSuffix"
                    formControlName="addressSalutation" [matAutocomplete]="auto" />
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                      (optionSelected)="setLetterSalutation($event)" [displayWith]="displayAddressSalutation">
                      @for (option of addressSalutionList; track option) {
                        <mat-option [value]="option">
                          {{ option | translate}}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              }
              @if (config.title.isVisible) {
                <div class="content-row d-flex flex-column half-size ">
                  <mat-form-field appearance="outline">
                    <mat-label>
                      {{'registerAddress.input.title.title' | translate}}
                    </mat-label>
                    <input matInput type="text" [id]="'intTitle' + idSuffix" formControlName="title" />
                  </mat-form-field>
                </div>
              }
              @if (config.letterSalutation.isVisible) {
                <div class="content-row d-flex flex-column full-width">
                  <mat-form-field appearance="outline" [id]="'sddLetterSalutation' + idSuffix ">
                    <mat-label>
                      {{'registerAddress.autocomplete.letterSalutation.title' | translate}}
                    </mat-label>
                    <input matInput type="text" [id]="'intLetterSalutation' + idSuffix"
                      formControlName="letterSalutation" [matAutocomplete]="autoLetterSalutation" />
                      <mat-autocomplete autoActiveFirstOption #autoLetterSalutation="matAutocomplete"
                        (optionSelected)="getSelectedSalutation($event)" [displayWith]="displayLetterSalutation">
                        @for (option of letterSalutionList; track option) {
                          <mat-option [value]="option">
                            {{ setLetterSalutationText(option) }}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                }
              </div>
            }
            @if (config.showSalutationsTitleSwitch) {
              <div class="full-width margin-top-bottom-10">
                @if (config.addressSalutation.isVisible || config.title.isVisible || config.letterSalutation.isVisible) {
                  <mat-slide-toggle formControlName="showSalutationsTitle"
                    >
                    {{ 'registerAddress.slideToggle.title.salutationsTitles' | translate }}
                  </mat-slide-toggle>
                }
              </div>
            }
            <!-- Address area-->
            @if (config.country.isVisible || config.language.isVisible || config.postCode.isVisible || config.city.isVisible || config.street.isVisible || config.houseNumber.isVisible) {
              <div class="container width-portrait" [class.width-landscape]="showStatesCantonControl.value"
                >
                <!-- Country -->
                @if (config.country.isVisible) {
                  <div class="width-flex-70">
                    <mat-form-field appearance="outline" [id]="'sddCountry' + idSuffix" class="full-width">
                      <mat-label>
                        {{ 'registerAddress.dropdown.country.title' | translate}}
                      </mat-label>
                      <mat-select formControlName="country1" (selectionChange)="handleCountryChange($event)">
                        @for (country of countryList; track country) {
                          <mat-option [value]="country">
                            {{ country.name }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                @if (config.language.isVisible) {
                  <div class="width-flex-30">
                    <mat-form-field [id]="'sddLanguage' + idSuffix" appearance="outline" class="full-width">
                      <mat-label>
                        {{ 'registerAddress.dropdown.language.title' | translate }}
                      </mat-label>
                      <mat-select formControlName="language">
                        @for (language of languageList; track language) {
                          <mat-option [value]="language">
                            {{ language }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                <!-- Post code -->
                @if (config.postCode.isVisible) {
                  <div class="content-row d-flex flex-column width-flex-30">
                    <mat-form-field class="full-width" appearance="outline" [id]="'sddPostCode' + idSuffix">
                      <mat-label>
                        {{'registerAddress.autocomplete.postCode.title' | translate}}
                      </mat-label>
                      <div class="d-flex"
                        [class.match-address-city-color]="selectedAddressCity !== undefined && countryControl.value.abbreviation === 'CH'"
                        [class.unmatch-address-city-color]="selectedAddressCity === undefined && postCodeControl.dirty && countryControl.value.abbreviation === 'CH'">
                        <input type="text" matInput formControlName="postCode" [matAutocomplete]="auto"
                          [id]="'intPostCode' + idSuffix"
                          [placeholder]="'registerAddress.autocomplete.postCode.title' | translate">
                          @if (showLoadingPostCity) {
                            <mat-progress-spinner diameter="25" [color]="'primary'"
                              [mode]="'indeterminate'">
                            </mat-progress-spinner>
                          }
                        </div>
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayPostCode" panelWidth="auto"
                          (optionSelected)="onSelectedPostCode($event)">
                          @for (option of filteredPostCode; track option) {
                            <mat-option [value]="option">
                              {{option.postCode + ' '+ option.name + ' ' + option.county}}
                            </mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>
                  }
                  <!-- City -->
                  @if (config.city.isVisible) {
                    <div class="content-row d-flex flex-column width-flex-70">
                      <mat-form-field class="full-width" appearance="outline">
                        <mat-label>
                          {{'registerAddress.autocomplete.city.title' | translate}}
                        </mat-label>
                        <div class="d-flex"
                          [class.match-address-city-color]="selectedAddressCity !== undefined && countryControl.value.abbreviation === 'CH'"
                          [class.unmatch-address-city-color]="selectedAddressCity === undefined && cityControl.dirty && countryControl.value.abbreviation === 'CH'">
                          <input type="text" [id]="'intCity' + idSuffix" matInput formControlName="city"
                            [matAutocomplete]="autoCompleteCity"
                            [placeholder]="'registerAddress.autocomplete.city.title' | translate">
                            @if (showLoadingPostCity) {
                              <mat-progress-spinner diameter="25" [color]="'primary'"
                                [mode]="'indeterminate'">
                              </mat-progress-spinner>
                            }
                          </div>
                          <mat-autocomplete #autoCompleteCity="matAutocomplete" [displayWith]="displayGenerique"
                            (optionSelected)="onSelectedCity($event)">
                            @for (option of filteredCity; track option) {
                              <mat-option [value]="option">
                                {{option.postCode + ' ' + option.name + ' ' + option.county}}
                              </mat-option>
                            }
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>
                    }
                    <!-- Street -->
                    @if (config.street.isVisible) {
                      <div class="content-row d-flex flex-column width-flex-70">
                        <mat-form-field class="full-width" appearance="outline" [id]="'sddStreet' + idSuffix">
                          <mat-label>
                            {{'registerAddress.autocomplete.street.title' | translate}}
                          </mat-label>
                          <div class="d-flex"
                            [class.match-address-city-color]="selectedPosStreet !== undefined && countryControl.value.abbreviation === 'CH'"
                            [class.unmatch-address-city-color]="selectedPosStreet === undefined && streetControl.dirty && countryControl.value.abbreviation === 'CH'">
                            <input [id]="'intStreet' + idSuffix" type="text" matInput formControlName="street"
                              [matAutocomplete]="autoCompletePostStreet"
                              [placeholder]="'registerAddress.autocomplete.street.title' | translate">
                            </div>
                            <mat-autocomplete #autoCompletePostStreet="matAutocomplete" [displayWith]="displayGenerique"
                              (optionSelected)="onSelectedPostStreet($event)">
                              @for (option of postStreetList; track option) {
                                <mat-option [value]="option">
                                  {{option.name}}
                                </mat-option>
                              }
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>
                      }
                      @if (config.houseNumber.isVisible) {
                        <div class="content-row d-flex flex-column width-flex-30">
                          <mat-form-field appearance="outline">
                            <mat-label>
                              {{'registerAddress.input.houseNumber.title' | translate}}
                            </mat-label>
                            <input matInput type="text" [id]="'intHouseNumber' + idSuffix" formControlName="houseNumber" />
                          </mat-form-field>
                        </div>
                      }
                    </div>
                  }
                  <!-- Canton area -->
                  @if (showStatesCantonControl.value) {
                    <div class="container width-portrait width-landscape margin-top-gt-md">
                      @if (config.county.isVisible) {
                        <div class="content-row d-flex flex-column half-size">
                          @if (countryControl.value.abbreviation === 'CH') {
                            <mat-form-field class="full-width" appearance="outline" [id]="'sddCounty' + idSuffix"
                              >
                              <mat-label>
                                {{'registerAddress.autocomplete.canton.title' | translate}}
                              </mat-label>
                              <mat-select formControlName="county">
                                @for (option of countyList; track option) {
                                  <mat-option [value]="option">
                                    {{option}}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          }
                          @if (countryControl.value.abbreviation !== 'CH') {
                            <mat-form-field appearance="outline">
                              <mat-label>
                                {{'registerAddress.autocomplete.canton.title' | translate}}
                              </mat-label>
                              <input matInput type="text" [id]="'intCounty' + idSuffix" formControlName="county" />
                            </mat-form-field>
                          }
                        </div>
                      }
                      @if (config.state.isVisible) {
                        <div class="content-row d-flex flex-column half-size">
                          <mat-form-field appearance="outline" class="mat-form-field " [id]="'sddState' + idSuffix">
                            <mat-label>
                              {{'registerAddress.dropdown.state.title' | translate}}
                            </mat-label>
                            <mat-select formControlName="country2">
                              @for (state of countryList; track state) {
                                <mat-option [value]="state">
                                  {{ translateCountryName(state) }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                      }
                    </div>
                  }
                  @if (config.showStatesCantonSwitch) {
                    <div class="full-width margin-top-10">
                      @if (config.county.isVisible || config.state.isVisible) {
                        <mat-slide-toggle formControlName="showStatesCanton"
                          >
                          {{ 'registerAddress.slideToggle.cantonState.title' | translate }}
                        </mat-slide-toggle>
                      }
                    </div>
                  }
                  @if (config.showPhonesSwitch) {
                    <div class="full-width margin-top-bottom-10">
                      @if (config.privatePhone.isVisible || config.cellPhone.isVisible || config.businessPhone.isVisible) {
                        <mat-slide-toggle formControlName="showPhones"
                          >
                          {{ 'registerAddress.slideToggle.telephone.title' | translate }}
                        </mat-slide-toggle>
                      }
                    </div>
                  }
                  <!-- Telephone area -->
                  <div class="container">
                    @if ((config.privatePhone.isVisible || config.cellPhone.isVisible) && showPhonesControl.value ) {
                      <div class="content-row phone-area half-size"
                        >
                        @if (config.privatePhone.isVisible) {
                          <mat-form-field appearance="outline" class="full-width">
                            <mat-label>
                              {{'registerAddress.input.telephonePrivate.title' | translate}}
                            </mat-label>
                            <input type="text" dianaTelephoneInput matInput [id]="'intPrivatePhone' + idSuffix"
                              formControlName="privatePhone" />
                            </mat-form-field>
                          }
                          @if (config.cellPhone.isVisible && showPhonesControl.value) {
                            <mat-form-field appearance="outline"
                              class="full-width">
                              <mat-label>
                                {{'registerAddress.input.cellPhone.title' | translate}}
                              </mat-label>
                              <input type="tel" dianaTelephoneInput matInput [id]="'intCellPhone' + idSuffix"
                                formControlName="cellPhone" />
                              </mat-form-field>
                            }
                            @if (config.cellPhone2.isVisible && showPhonesControl.value) {
                              <mat-form-field appearance="outline"
                                class="full-width">
                                <mat-label>
                                  {{'registerAddress.input.cellPhone.title2' | translate}}
                                </mat-label>
                                <input type="tel" dianaTelephoneInput matInput [id]="'intCellPhone2' + idSuffix"
                                  formControlName="cellPhone2" />
                                </mat-form-field>
                              }
                            </div>
                          }
                          @if (config.businessPhone.isVisible && showPhonesControl.value) {
                            <div class="content-row d-flex flex-column half-size"
                              >
                              <mat-form-field appearance="outline">
                                <mat-label>
                                  {{'registerAddress.input.telephoneBusiness.title' | translate}}
                                </mat-label>
                                <input type="tel" dianaTelephoneInput matInput [id]="'intBusinessPhone' + idSuffix"
                                  formControlName="businessPhone" />
                                </mat-form-field>
                              </div>
                            }
                            @if (config.showWebSwitch) {
                              <div class="full-width margin-top-bottom-10">
                                @if (config.eMail.isVisible || config.web.isVisible) {
                                  <mat-slide-toggle formControlName="showWeb">
                                    {{ 'registerAddress.slideToggle.emailWeb.title' | translate }}
                                  </mat-slide-toggle>
                                }
                              </div>
                            }
                            @if (config.eMail.isVisible && showWebControl.value) {
                              <div class="content-row d-flex flex-column width-portrait width-landscape"
                                >
                                <mat-form-field appearance="outline">
                                  <mat-label>
                                    {{'registerAddress.input.email.title' | translate}}
                                  </mat-label>
                                  <input matInput type="email" [id]="'intEmail' + idSuffix" formControlName="eMail" />
                                </mat-form-field>
                              </div>
                            }
                            @if (config.web.isVisible && showWebControl.value) {
                              <div class="content-row d-flex flex-column half-size  width-portrait"
                                >
                                <mat-form-field appearance="outline">
                                  <mat-label>
                                    {{'registerAddress.input.webPage.title' | translate}}
                                  </mat-label>
                                  <input matInput type="text" [id]="'intWeb' + idSuffix" formControlName="web" />
                                </mat-form-field>
                              </div>
                            }
                          </div>
                        </form>
                      }
                      <!-- Readonly address form -->
                      @if (readOnly) {
                        <form [formGroup]="formGroup" class="full-width container overflow-auto" autocomplete="off">
                          <!-- User data -->
                          @if (config.firstName.isVisible || config.lastName.isVisible || config.firmName.isVisible) {
                            <div class="container width-portrait" [class.width-landscape]="showSalutationsTitleControl.value"
                              >
                              @if (config.firstName.isVisible) {
                                <div class="content-row d-flex flex-column half-size">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: firstNameControl.value,  label: 'registerAddress.input.firstName.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                              @if (config.lastName.isVisible) {
                                <div class="content-row d-flex flex-column half-size ">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: lastNameControl.value,  label: 'registerAddress.input.lastName.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                              @if (config.firmName.isVisible) {
                                <div class="content-row d-flex flex-column full-width">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: firmNameControl.value,  label: 'registerAddress.input.firstName.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                            </div>
                          }
                          <!-- Salutaion area -->
                          @if (showSalutationsTitleControl.value) {
                            <div class="container width-portrait width-landscape ">
                              @if (config.addressSalutation.isVisible) {
                                <div class="content-row d-flex flex-column half-size">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: addressSalutationControl.value | translate,  label: 'registerAddress.autocomplete.addressSalutation.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                              @if (config.title.isVisible) {
                                <div class="content-row d-flex flex-column half-size">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: titleControl.value | translate,  label: 'registerAddress.input.title.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                              @if (config.letterSalutation.isVisible) {
                                <div class="content-row d-flex flex-column full-width">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: letterSalutationControl.value?.name ? setLetterSalutationText(this.letterSalutationControl.value): letterSalutationControl.value | translate,  label: 'registerAddress.autocomplete.letterSalutation.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                            </div>
                          }
                          @if (config.showSalutationsTitleSwitch) {
                            <div class="full-width margin-top-bottom-10">
                              @if (config.addressSalutation.isVisible || config.title.isVisible || config.letterSalutation.isVisible) {
                                <mat-slide-toggle formControlName="showSalutationsTitle"
                                  >
                                  {{ 'registerAddress.slideToggle.title.salutationsTitles' | translate }}
                                </mat-slide-toggle>
                              }
                            </div>
                          }
                          <!-- Address area-->
                          @if (config.country.isVisible || config.language.isVisible || config.postCode.isVisible || config.city.isVisible || config.street.isVisible || config.houseNumber.isVisible) {
                            <div class="container width-portrait" [class.width-landscape]="showStatesCantonControl.value"
                              >
                              <!-- Country -->
                              @if (config.country.isVisible) {
                                <div class="half-size">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: translateCountryName(countryControl.value),  label: 'registerAddress.dropdown.country.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                              @if (config.language.isVisible) {
                                <div class="half-size">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: languageControl.value,  label: 'registerAddress.dropdown.language.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                              <!-- Post code -->
                              @if (config.postCode.isVisible) {
                                <div class="content-row d-flex flex-column half-size">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: postCodeControl.value.postCode ?  postCodeControl.value.postCode:  postCodeControl.value,  label: 'registerAddress.autocomplete.postCode.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                              <!-- City -->
                              @if (config.city.isVisible) {
                                <div class="content-row d-flex flex-column half-size">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: cityControl.value.name ?  cityControl.value.name:  cityControl.value,  label: 'registerAddress.autocomplete.city.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                              <!-- Street -->
                              @if (config.street.isVisible) {
                                <div class="content-row d-flex flex-column half-size">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: streetControl.value.name ?  streetControl.value.name:  streetControl.value,  label: 'registerAddress.autocomplete.street.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                              @if (config.houseNumber.isVisible) {
                                <div class="content-row d-flex flex-column half-size">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: houseNumberControl.value,  label: 'registerAddress.input.houseNumber.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                            </div>
                          }
                          <!-- Canton area -->
                          @if (showStatesCantonControl.value) {
                            <div class="container width-portrait width-landscape ">
                              @if (config.county.isVisible) {
                                <div class="content-row d-flex flex-column half-size">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: countyControl.value,  label: 'registerAddress.autocomplete.canton.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                              @if (config.state.isVisible) {
                                <div class="content-row d-flex flex-column half-size ">
                                  <ng-container
                                    *ngTemplateOutlet="spanReadOnly; context: { value: translateCountryName(stateControl.value),  label: 'registerAddress.dropdown.state.title' | translate}">
                                  </ng-container>
                                </div>
                              }
                            </div>
                          }
                          @if (config.showStatesCantonSwitch) {
                            <div class="full-width margin-top-10">
                              @if (config.county.isVisible || config.state.isVisible) {
                                <mat-slide-toggle formControlName="showStatesCanton"
                                  >
                                  {{ 'registerAddress.slideToggle.cantonState.title' | translate }}
                                </mat-slide-toggle>
                              }
                            </div>
                          }
                          @if (config.showPhonesSwitch) {
                            <div class="full-width margin-top-bottom-10">
                              @if (config.privatePhone.isVisible || config.cellPhone.isVisible || config.businessPhone.isVisible) {
                                <mat-slide-toggle formControlName="showPhones"
                                  >
                                  {{ 'registerAddress.slideToggle.telephone.title' | translate }}
                                </mat-slide-toggle>
                              }
                            </div>
                          }
                          <!-- Telephone area -->
                          <div class="container">
                            @if ((config.privatePhone.isVisible || config.cellPhone.isVisible) && showPhonesControl.value ) {
                              <div class="content-row phone-area half-size"
                                >
                                <ng-container
                                  *ngTemplateOutlet="spanReadOnly; context: { value: privatePhoneControl.value,  label: 'registerAddress.input.telephonePrivate.title' | translate}">
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="spanReadOnly; context: { value: cellPhoneControl.value,  label: 'registerAddress.input.cellPhone.title' | translate}">
                                </ng-container>
                                <ng-container
                                  *ngTemplateOutlet="spanReadOnly; context: { value: cellPhone2Control.value,  label: 'registerAddress.input.cellPhone.title2' | translate}">
                                </ng-container>
                                @if (config.eMail.isVisible && showWebControl.value) {
                                  <div
                                    >
                                    <ng-container
                                      *ngTemplateOutlet="spanReadOnly; context: { value: eMailControl.value,  label: 'registerAddress.input.email.title' | translate}">
                                    </ng-container>
                                  </div>
                                }
                              </div>
                            }
                            @if (config.businessPhone.isVisible && showPhonesControl.value) {
                              <div class="content-row d-flex flex-column half-size"
                                >
                                <ng-container
                                  *ngTemplateOutlet="spanReadOnly; context: { value: businessPhoneControl.value,  label: 'registerAddress.input.telephoneBusiness.title' | translate}">
                                </ng-container>
                              </div>
                            }
                            @if (config.showWebSwitch) {
                              <div class="full-width margin-top-bottom-10">
                                @if (config.eMail.isVisible || config.web.isVisible) {
                                  <mat-slide-toggle formControlName="showWeb">
                                    {{ 'registerAddress.slideToggle.emailWeb.title' | translate }}
                                  </mat-slide-toggle>
                                }
                              </div>
                            }
                            @if (config.web.isVisible && showWebControl.value) {
                              <div class="content-row d-flex flex-column half-size  width-portrait "
                                >
                                <ng-container
                                  *ngTemplateOutlet="spanReadOnly; context: { value: webControl.value,  label: 'registerAddress.input.webPage.title' | translate}">
                                </ng-container>
                              </div>
                            }
                          </div>
                        </form>
                      }
                    </div>
                  }



                  <ng-template #spanReadOnly let-value="value" let-label="label">
                    <div class="align-content-center margin-bottom-10">
                      <span class="font-weight-700">{{ label }}: </span>{{ value}}
                    </div>
                  </ng-template>